import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalAffiliationContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    templateUrl: './historical-customer-affiliation-modal.html'
})
export class HistoricalCustomerAffiliationModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;

    constructor(public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerAffiliationModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalAffiliationContext,
        public modalService: MvdModalService) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() { }

    public cancel() {
        this.dialogRef.close();
    }
}
